module.exports = "<select class=\"select-lang form-control resource-header\" [(ngModel)]=\"currentSet\">\r\n  <option *ngFor=\"let set of sets\" [ngValue]=\"set\" l10nTranslate>{{set.Language}}</option>\r\n</select>\r\n<ng-container *ngIf=\"currentSet\">\r\n  <input class=\"form-control form-control-sm resource-row\" [ngClass]=\"{'missing':!currentSet.Resources[key]}\" *ngFor=\"let key of keys\" type=\"text\" [(ngModel)]=\"currentSet.Resources[key]\"/>\r\n</ng-container>"


//////////////////
// WEBPACK FOOTER
// C:/git/flowdesigner/src/app/resource-column/resource-column.component.html
// module id = ../../../../../src/app/resource-column/resource-column.component.html
// module chunks = 1